import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'next-i18next';

import { NavItem } from '@phoenix/core/frontend/shared/domain/static-content/static-content.static-generation.model';
import { link } from '@phoenix/core/frontend/shared/util/navigation/link.utils';

import { useCustomerSupportLink } from './use-customer-support-link';

export const useMyStihlNavItems = (navItems?: NavItem[]): NavItem[] | undefined => {
  const { t } = useTranslation('shared');
  const customerSupportLink = useCustomerSupportLink();

  const {
    'customer-support-navigation': isCustomerSupportEnabled,
    'my-guides': isMyGuidesEnabled,
    raffle: raffleEnabled,
    voucher: voucherEnabled,
  } = useFlags();

  const isBenefitsEnabled = raffleEnabled || voucherEnabled;

  return navItems
    ? [
        ...navItems,
        ...(isMyGuidesEnabled
          ? [
              {
                name: t('shared_myGuides'),
                id: 'my-guides',
                url: link('dashboard/my-guides'),
                type: 'Link',
              } as NavItem,
            ]
          : []),
        ...(isBenefitsEnabled
          ? [
              {
                name: t('shared_myBenefits'),
                id: 'my-benefits',
                url: link('tool-shed/my-benefits'),
                type: 'Link',
              } as NavItem,
            ]
          : []),
        ...(isCustomerSupportEnabled
          ? [
              {
                name: t('shared_customerSupport'),
                id: 'customer-support',
                url: customerSupportLink,
                type: 'Link',
              } as NavItem,
            ]
          : []),
      ]
    : navItems;
};
